import React, { useState } from 'react';

import type { ToolbarContextType } from './../../../../ricos-context';
import { withToolbarContext } from './../../../../ricos-context';
import { getIsModalOpen, useModalState } from './../../../../ricos-modals/modal-service-provider';
import type { IToolbarItem } from './../../../../ricos-types/toolbarTypes';

import { DropdownArrowIcon } from '../../../icons';
import { ToolbarButton } from '../ToolbarButton';

const AlignmentButton = ({
  toolbarItem,
  context,
  dataHook,
}: {
  toolbarItem: IToolbarItem;
  context: ToolbarContextType;
  dataHook?: string;
}) => {
  const { isMobile, t, getPublicCommands } = context;
  const [referenceElement, setReferenceElement] = useState<HTMLButtonElement | null>(null);
  const publicCommands = getPublicCommands?.();
  const Icon = toolbarItem.presentation.getIcon(publicCommands);
  const tooltip = t(toolbarItem.presentation?.tooltip);

  const isModalOpen = useModalState(getIsModalOpen('TextAlignment.modal'));

  return (
    <ToolbarButton
      ref={setReferenceElement}
      disabled={toolbarItem.attributes.disabled}
      isMobile={isMobile}
      active={isModalOpen}
      tooltip={tooltip}
      onClick={e => {
        toolbarItem.commands?.click({ referenceElement, clickFromKeyboard: !e.detail });
      }}
      icon={() => (
        <>
          <Icon />
          <DropdownArrowIcon />
        </>
      )}
      dataHook={dataHook}
    />
  );
};

export default withToolbarContext(AlignmentButton);
